var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "biz-selector-content border-primary-6",
      class: { disabled: _vm.disabled },
    },
    [
      _c(
        "yxt-scrollbar",
        { attrs: { "wrap-class": "udp-select-outer__scroll" } },
        [
          _c(
            "div",
            { staticClass: "biz-selector-content-taglist" },
            [
              _vm.value.length > 0
                ? _vm._l(_vm.value, function (tag) {
                    return _c(
                      "yxt-tag",
                      {
                        key: tag[_vm.labelKey],
                        staticClass: "mb6 mr4",
                        attrs: { type: "info", size: _vm.size, closable: "" },
                        on: {
                          close: function ($event) {
                            return _vm.deleteTag(tag)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(tag[_vm.labelKey]) +
                            "\n          "
                        ),
                        tag.includeAll
                          ? [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "pc_gwnl_selectOuter_group_lbl_includeAll"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  })
                : _vm.defaultTag
                ? [
                    _c(
                      "yxt-tag",
                      {
                        attrs: { type: "info", size: _vm.size, closable: "" },
                        on: {
                          close: function ($event) {
                            return _vm.deleteTag(_vm.tag)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.defaultTag) + "\n        "
                        ),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "color-gray-6 standard-size-14 mt1" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.placeholder) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
      _c("yxt-svg", {
        staticClass: "biz-selector-content__icon color-gray-6 hover-primary-6",
        attrs: { width: "28px", height: "28px", "icon-class": "three-dot" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }